import { request, requestUpload } from '../../utils'

export const addSpeaker = (liveId, speakerData) => {
  const url = '/api/live/speaker/add'

  return request({
    url,
    method: 'POST',
    data: {
      live_id: liveId,
      ...speakerData,
    },
  })
}

export const editSpeaker = (data) => {
  const url = '/api/live/speaker/update'

  return request({
    url,
    method: 'POST',
    data,
  })
}

export const editSpeakerAvatar = (speakerId, data) => {
  const url = '/api/live/speaker/set-avatar'

  return requestUpload({
    url,
    files: [[data.filename, data.file]],
    data: {
      live_speaker_id: speakerId,
    },
  })
}

export const removeSpeakerAvatar = (speakerId) => {
  const url = '/api/live/speaker/remove-avatar'

  return request({
    url,
    data: {
      live_speaker_id: speakerId,
    },
  })
}

export const deleteSpeaker = (speakerId) => {
  const url = '/api/live/speaker/remove'

  return request({
    url,
    method: 'POST',
    data: {
      live_speaker_id: speakerId,
    },
  })
}

export const sendInviteEmail = (speakerId, liveId) => {
  const url = '/api/live/speaker/send-invitation'

  return request({
    url,
    data: {
      live_speaker_id: speakerId,
      live_id: liveId,
    },
  })
}

export const getSpeakers = (
  liveId,
  token,
  isExcludingHidden = false,
  isIncludingHiddenGuestSpeakers = false
) => {
  const url = '/api/live/speaker/list'

  return request({
    url,
    method: 'POST',
    data: {
      live_id: liveId,
      token,
      exclude_hidden_p: isExcludingHidden ? 1 : 0,
      include_hidden_guest_speakers_p: isIncludingHiddenGuestSpeakers ? 1 : 0,
    },
  })
}

export const fetchSettings = () =>
  request({
    url: '/api/setting/list',
  })

export const reorderSpeakers = (liveId, order) => {
  const url = '/api/live/speaker/set-order'

  return request({
    url,
    method: 'POST',
    data: {
      live_id: liveId,
      order,
    },
  })
}
